<dx-popup
    #manageProposalPopup
    minWidth="150px"
    minHeight="150px"
    width="60%"
    height="90%"
    [title]="workOrderTitle"
    [showTitle]="true"
    [showCloseButton]="true"
    [shading]="false"
    [dragEnabled]="true"
    [resizeEnabled]="true"
    [closeOnOutsideClick]="false"
    [(visible)]="visible"
    (onShown)="onPopupShown()"
    (onHidden)="onPopupClose()"
>
    <div *dxTemplate="let data of 'content'">
        <dx-box width="100%" height="100%" direction="col" class="manage-proposal-container">
            <dxi-item [ratio]="1">
                <div *dxTemplate>
                    <dx-box *ngIf="workOrderProposal" width="100%" height="100%" direction="col">
                        <dxi-item baseSize="auto">
                            <div *dxTemplate>
                                <dx-form width="100%" height="100%" [colCount]="1">
                                    <dxi-item itemType="group" [colCount]="2">
                                        <dxi-item>
                                            <dxo-label text="Community"></dxo-label>
                                            <div *dxTemplate>
                                                <dx-text-box
                                                    [readOnly]="true"
                                                    [value]="workOrderProposal.communityName"
                                                ></dx-text-box>
                                            </div>
                                        </dxi-item>
                                        <dxi-item>
                                            <dxo-label text="Work Order #"></dxo-label>
                                            <div *dxTemplate>
                                                <div class="row-container">
                                                    <div class="input-container">
                                                        <dx-text-box
                                                            [elementAttr]="{ class: 'text-content' }"
                                                            [readOnly]="true"
                                                            [value]="workOrderId"
                                                        ></dx-text-box>
                                                    </div>
                                                    <div
                                                        *ngIf="isInternalUser"
                                                        class="icon-content-container"
                                                        (click)="onProposalNotesClick()"
                                                    >
                                                        <ng-container *ngIf="!workOrderProposal.hasNotes">
                                                            <i
                                                                class="fa-2x icon-content dx-theme-accent-as-text-color"
                                                                title="Internal Notes"
                                                                [ngClass]="iconEmptyNotes"
                                                            ></i>
                                                        </ng-container>
                                                        <ng-container *ngIf="workOrderProposal.hasNotes">
                                                            <i
                                                                class="fa-2x icon-content cc-icon-check"
                                                                title="Internal Notes"
                                                                [ngClass]="iconNotes"
                                                            ></i>
                                                        </ng-container>
                                                    </div>
                                                </div>
                                            </div>
                                        </dxi-item>
                                    </dxi-item>

                                    <dxi-item itemType="group" caption="Vendor Proposals" [colCount]="1">
                                        <dxi-item>
                                            <div *dxTemplate>
                                                <dx-toolbar width="100%">
                                                    <dxi-item location="before">
                                                        <div *dxTemplate>
                                                            <dx-button
                                                                type="default"
                                                                text="Add Vendor For Proposal"
                                                                hint="Add Vendor For Proposal"
                                                                [icon]="iconPlus"
                                                                (onClick)="onAddVendorForProposal()"
                                                            ></dx-button>
                                                        </div>
                                                    </dxi-item>
                                                    <dxi-item location="after">
                                                        <div *dxTemplate>
                                                            <dx-button
                                                                type="default"
                                                                text="Regenerate Proposal Requests"
                                                                hint="Regenerate Proposal Requests"
                                                                [disabled]="vendorProposals?.length === 0"
                                                                (onClick)="onRegenerateProposalRequest()"
                                                            ></dx-button>
                                                        </div>
                                                    </dxi-item>
                                                </dx-toolbar>
                                            </div>
                                        </dxi-item>
                                    </dxi-item>
                                </dx-form>
                            </div>
                        </dxi-item>
                        <dxi-item [ratio]="1">
                            <div *dxTemplate>
                                <div class="vendor-proposal-container dx-theme-border-color">
                                    <cc-data-grid-features
                                        [stateConfig]="{ storageKey: 'VENDOR_PROPOSALS', storeGroupings: true }"
                                        [dataSource]="vendorProposals"
                                    >
                                        <dx-data-grid
                                            #vendorProposalGrid
                                            width="100%"
                                            height="100%"
                                            [dataSource]="vendorProposals"
                                            (onContentReady)="onGridContentReady()"
                                        >
                                            <dxi-column
                                                caption="Action"
                                                cellTemplate="actionButtonTemplate"
                                                alignment="center"
                                                type="buttons"
                                                [width]="110"
                                                [visibleIndex]="0"
                                                [allowFiltering]="false"
                                                [allowHeaderFiltering]="false"
                                                [allowGrouping]="false"
                                                [allowSorting]="false"
                                                [showInColumnChooser]="false"
                                            ></dxi-column>
                                            <dxi-column
                                                dataType="string"
                                                dataField="vendorName"
                                                caption="Vendor Name"
                                            ></dxi-column>
                                            <dxi-column
                                                dataType="date"
                                                dataField="lastGenerated"
                                                caption="Last Generated"
                                                [format]="dateFormat"
                                            ></dxi-column>
                                            <dxi-column
                                                dataType="boolean"
                                                dataField="hasRfpDocument"
                                                caption="RFP"
                                                cellTemplate="pdfTemplate"
                                                alignment="center"
                                                [width]="70"
                                            ></dxi-column>
                                            <dxi-column
                                                caption="Email"
                                                cellTemplate="emailTemplate"
                                                alignment="center"
                                                [width]="70"
                                            ></dxi-column>
                                            <dxi-column
                                                dataType="number"
                                                dataField="estimatedAmount"
                                                caption="Estimate"
                                                [format]="currencyFormat"
                                            ></dxi-column>
                                            <dxi-column
                                                dataType="boolean"
                                                caption="History"
                                                dataField="hasRfpDocument"
                                                cellTemplate="logTemplate"
                                                alignment="center"
                                                [width]="70"
                                            ></dxi-column>
                                            <dxi-column
                                                dataType="number"
                                                dataField="attachmentCount"
                                                caption="Quote"
                                                cellTemplate="attachmentCellTemplate"
                                                alignment="center"
                                                [width]="90"
                                            ></dxi-column>

                                            <div *dxTemplate="let d of 'attachmentCellTemplate'">
                                                <div class="attachment-container">
                                                    <i
                                                        class="cc-1-5x dx-theme-accent-as-text-color icon-content"
                                                        title="Quotes"
                                                        [ngClass]="iconAttachment"
                                                        (click)="onGridAttachmentClick(d.data)"
                                                    ></i>
                                                    <ng-container *ngIf="d.data.attachmentCount > 0">
                                                        ({{ d.data.attachmentCount }})
                                                    </ng-container>
                                                </div>
                                            </div>

                                            <div *dxTemplate="let d of 'logTemplate'">
                                                <ng-container *ngIf="d.data.hasRfpDocument">
                                                    <i
                                                        class="cc-1-5x icon-content dx-theme-accent-as-text-color"
                                                        title="Logs"
                                                        [ngClass]="iconHistory"
                                                        (click)="onProposalHistoryClick(d.data)"
                                                    ></i>
                                                </ng-container>
                                            </div>

                                            <div *dxTemplate="let d of 'emailTemplate'">
                                                <i
                                                    class="cc-1-5x icon-content dx-theme-accent-as-text-color"
                                                    title="Open Email Composer"
                                                    [ngClass]="iconEmail"
                                                    (click)="onEmailClick(d.data)"
                                                ></i>
                                            </div>

                                            <div *dxTemplate="let d of 'pdfTemplate'">
                                                <ng-container *ngIf="d.data.hasRfpDocument">
                                                    <i
                                                        class="cc-1-5x icon-content cc-icon-pdf"
                                                        title="Open RFP Document"
                                                        [ngClass]="iconPDF"
                                                        (click)="onRPFDownloadFile(d.data)"
                                                    ></i>
                                                </ng-container>
                                            </div>

                                            <div *dxTemplate="let t of 'actionButtonTemplate'">
                                                <app-grid-actions-menu
                                                    [actionMenuItems]="actionMenuItems"
                                                    [record]="t.data"
                                                    [rowIndex]="t.rowIndex"
                                                    [isActionVisible]="isActionItemVisible"
                                                    (onActionClick)="onActionItemClick($event)"
                                                ></app-grid-actions-menu>
                                            </div>
                                        </dx-data-grid>
                                    </cc-data-grid-features>
                                </div>
                            </div>
                        </dxi-item>
                        <dxi-item baseSize="auto">
                            <div *dxTemplate>
                                <dx-form width="100%" height="100%" class="vendor-info-container" [colCount]="1">
                                    <dxi-item itemType="group" caption="Accepted Work Order Vendor Info" [colCount]="1">
                                        <dxi-item>
                                            <dxo-label text="Vendor Name"></dxo-label>
                                            <div *dxTemplate>
                                                <dx-text-box
                                                    [readOnly]="true"
                                                    [value]="workOrderProposal.vendorName"
                                                ></dx-text-box>
                                            </div>
                                        </dxi-item>
                                        <dxi-item>
                                            <dxo-label text="Vendor Estimate"></dxo-label>
                                            <div *dxTemplate>
                                                <dx-number-box
                                                    [readOnly]="true"
                                                    [format]="currencyFormat"
                                                    [value]="workOrderProposal.vendorEstimate"
                                                ></dx-number-box>
                                            </div>
                                        </dxi-item>
                                    </dxi-item>
                                </dx-form>
                            </div>
                        </dxi-item>
                    </dx-box>
                </div>
            </dxi-item>
            <dxi-item baseSize="auto">
                <div *dxTemplate>
                    <!-- 
                        In v1, Save, SaveAndClose buttons are available.
                        In v2, Save, SaveAndClose buttons are removed.
                        Agreed with Sandeep Yeri and Murthy M.K on 3rd Sept 2022.
                    -->
                    <dx-toolbar width="100%">
                        <dxi-item location="before">
                            <div *dxTemplate>
                                <dx-button
                                    type="default"
                                    text="Edit Work Order"
                                    hint="Edit Work Order"
                                    [icon]="iconEdit"
                                    (onClick)="onEditWorkOrderClick()"
                                ></dx-button>
                            </div>
                        </dxi-item>
                        <dxi-item location="before">
                            <div *dxTemplate>
                                <dx-button
                                    type="default"
                                    text="Manage Work Authorization"
                                    hint="Manage Work Authorization"
                                    (onClick)="onManageWorkAuthorizationClick()"
                                ></dx-button>
                            </div>
                        </dxi-item>
                        <dxi-item location="after">
                            <div *dxTemplate>
                                <dx-button
                                    type="default"
                                    text="Close"
                                    hint="Close"
                                    [icon]="iconClose"
                                    (onClick)="onPopupClose()"
                                ></dx-button>
                            </div>
                        </dxi-item>
                    </dx-toolbar>
                </div>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>

<app-work-orders-notes-editor
    *ngIf="showNotes"
    [communityId]="communityId"
    [workOrderId]="workOrderId"
    (onClose)="onProposalNotesClose($event)"
></app-work-orders-notes-editor>

<app-select-vendor-for-proposal
    *ngIf="showAddVendorForProposal"
    selection="multiple"
    [communityId]="communityId"
    [workOrderId]="workOrderId"
    (onVendorSelection)="onVendorSelection($event)"
    (onClose)="onAddVendorProposalClose()"
></app-select-vendor-for-proposal>

<app-work-order-proposal-history
    *ngIf="showProposalHistory"
    [communityId]="communityId"
    [workOrderId]="workOrderId"
    [workOrderProposalId]="selectedProposal?.proposalId"
    (onClose)="onProposalHistoryClose()"
></app-work-order-proposal-history>

<app-manage-quotes
    *ngIf="showProposalQuoteManager"
    [communityId]="communityId"
    [workOrderId]="workOrderId"
    [customerId]="customerId"
    [workOrderProposalId]="selectedProposal?.proposalId"
    (onClose)="onQuoteManagerClose()"
></app-manage-quotes>

<app-propsal-accept-editor
    *ngIf="showAcceptPropsalEditor"
    [communityId]="communityId"
    [workOrderId]="workOrderId"
    [workOrderProposalId]="selectedProposal?.proposalId"
    [quotesList]="quotesList"
    (onClose)="onAcceptProposalEditorClose()"
></app-propsal-accept-editor>

<app-edit-vendor-for-proposal
    *ngIf="showVendorForProposalEditor"
    [communityId]="communityId"
    [workOrderId]="workOrderId"
    [customerId]="customerId"
    [estimatedAmount]="selectedProposal?.estimatedAmount"
    [workOrderProposalId]="selectedProposal?.proposalId"
    (onClose)="onVendorForProposalEditorClose()"
></app-edit-vendor-for-proposal>
